import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import notFoundImg from '../../static/images/common/not-found-img.png';
import { comparePrePropsAndNextProps } from '../../lib/common';
import { appActions } from '../../store/modules/app';
import './Img.scss';

class Img extends Component {
  constructor(props) {
    super(props);

    this.state = {
      src: this.props.src,
    };
  }

  /**
   * Props 값이 변경이 되었을 때, state 의 값을 변경
   */
  UNSAFE_componentWillReceiveProps(props) {
    if (props.src && comparePrePropsAndNextProps([[props.src, this.props.src]])) {
      this.setState({
        src: props.src,
      });
    }
  }

  onError = () => {
    this.setState({
      src: notFoundImg,
    });
  };

  render() {
    const { src } = this.state;
    const { className, effect, appToggleModal, clickAble = true, ...res } = this.props;
    return (
      <img
        className={cx('amondz-img', { effect }, className)}
        onError={() => this.onError()}
        onClick={() =>
          clickAble &&
          appToggleModal({
            name: 'imgViewModal',
            data: {
              url: src,
            },
          })
        }
        {...res}
        src={src}
      />
    );
  }
}

const mapDispatchToProps = {
  appToggleModal: appActions.appToggleModal,
};

export default connect(null, mapDispatchToProps)(Img);
